import styled from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
export const Wrapper = styled.div `
  text-align: left;
  width: 100%;
  background: ${newColors.snow};
  padding: 49px;
  ${mediaq.sm `
    padding: 24px 0 0;
    width: auto;
  `}
`;
export const Header = styled.h4 `
  font-family: 'Inria Serif', serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: ${newColors.gray800};
`;
export const Message = styled.p `
  font-family: 'Inter Variable', sans-serif;
  position: relative;
  font-weight: 400;
  font-size: 14px;
  line-height: ${(props) => (props.multipleLine ? '18px' : '22px')};
  white-space: pre-line;
  margin-top: 36px;
  max-width: 372px;
  color: ${newColors.gray800};
  ${mediaq.sm `
  margin-top: 16px;
  `}
`;
